module.exports = __webpack_public_path__ + "img/banner25-2.706beb5b.jpg";